<template>
  <div>
    <div class="leftBar">
      <div class="customerWrapper">
        <div class="customerTitle">当前客户</div>
        <div class="customerBtn" @click="dialogCustomer = true">
          <div class="customerName">{{ customerName }}</div>
          <i
            class="el-icon-close"
            v-show="closeIcon"
            @click.stop="resetCustomer"
          ></i>
        </div>
      </div>
      <div class="numsWrapper">
        <el-input
          class="textareaNum"
          style="width: 100%;"
          type="textarea"
          :rows="15"
          v-model="listQuery.numberlist"
          @blur="FormatNumTxt(listQuery.numberlist)"
          placeholder="默认搜索产品品牌为菲尔，如要搜索其他品牌产品请在产品类型中选择。请输入OE号码，若多个OE号请按Enter键换行。示例： 11128645888 2218350064 51218402502"
        ></el-input>
        <div class="numsBtnWrapper">
          <div class="marginT displayB">
            <el-button
              style="width: 65px;"
              type="primary"
              plain
              @click="clearNums"
              >清空</el-button
            >
            <el-button style="width: 65px;" type="primary" @click="searchNums()"
              >搜 索</el-button
            >
          </div>
          <div class="marginT">
            <el-upload
              class="upload-demo"
              action="https://api.freyparts.cn/Shop.Accessories/fromxls"
              :headers="myHeaders"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <el-button type="primary" class="upBtn"
                >导入Excel批量搜索</el-button
              >
            </el-upload>
          </div>
          <div class="marginT">
            <el-button
              class="downBtn"
              type="primary"
              plain
              @click="downloadTemplate"
              >下载模板</el-button
            >
          </div>
        </div>
      </div>
      <div class="VinWrapper" v-loading="vinLoading" element-loading-text="识别中">
        <el-input
          class="searchIpt"
          ref="VINSearchIpt"
          v-model="listQuery.vin"
          clearable
          @keyup.enter.native="VINSearch"
          @paste.native.capture.prevent="pasting"
          placeholder="请输入VIN号码"
        ></el-input>
        <div class="VINbtnWrapper">
          <div class="VINiptBox">
            <input
              class="VINipt"
              ref="imgInput"
              type="file"
              accept="image/*"
              @change="searchVINImg($event)"
            />
            <el-button size="small" type="file" class="VINbtn">
              VIN识图
            </el-button>
          </div>
          <el-button type="primary" style="width: 65px;" @click="VINSearch"
            >搜 索</el-button
          >
        </div>
      </div>
    </div>
    <!-- 打开客户选择弹窗组件 -->
    <customer-select
      :dialogCustomer="dialogCustomer"
      @click="addNew"
      @handleClose="closeDialog"
    ></customer-select>

  </div>
</template>

<script>
  import { setCookie, getCookie, removeCookie } from "@/utils/support";
  import customerSelect from "@/components/customerSelect";
  import { VinOcr } from "@/api/product";
  var ls = window.localStorage;
  var token = getCookie("crmToken"); // 要保证取到
  var company_id = getCookie("company_id"); // 要保证取到
  const defaultListQuery = {
    vin: null,
    keyword: null,
    aikeyword: null,
    number: null,
    numberlist: null,
    // numList: null,
    customer_id: ls.getItem("partner_id") ? ls.getItem("partner_id") : null,
    page: 1,
    limit: 20
  };
  export default {
    components: {
      customerSelect
    },
    props: {
      currentIndex: { // 父组件传递过来的表头数据
        type: Number
      },
      partner_id:{   // 父组件传递过来的id
        type: [Number,String]
      },
    },
    data() {
      return {
        myHeaders: { Authorization: token },
        listQuery: Object.assign({}, defaultListQuery),
        dialogCustomer: false,
        customerName: ls.getItem("customerName")? ls.getItem("customerName"): "请选择当前客户",
        closeIcon: ls.getItem("customerName") ? true : false,
        vinLoading:false,
      }
    },
    watch: {
      // $route() {
      //   this.getBreadcrumb()
      // }
    },
    created() {
      // this.getBreadcrumb()
    },
    methods: {
      // 客户选择搜索
      addNew(row) {
        // console.log(row)
        this.listQuery.customer_id = row.partner_id;
        this.dialogCustomer = false;
        this.customerName = row.fullname;
        ls.setItem("customerName", row.fullname);
        ls.setItem("partner_id", row.partner_id);
        this.closeIcon = true;
        this.listQuery.vin = null;
        this.listQuery.page = 1;
        // this.getList();
        this.$router.push({path: '/product/productCP',query:{listQuery:JSON.stringify(this.listQuery),time:new Date().getSeconds()}});
      },
      closeDialog() {
        this.dialogCustomer = false;
      },
      // 重置客户选择
      resetCustomer() {
        ls.removeItem("partner_id");
        ls.removeItem("customerName");
        this.customerName = "请选择当前客户";
        this.closeIcon = false;
        this.listQuery.customer_id = null;
        this.listQuery.vin = null;
        // this.getList();
        this.$router.push({path: '/product/productCP',query:{listQuery:JSON.stringify(this.listQuery),time:new Date().getSeconds()}});
      },

      // 多号码搜索格式转化
      FormatNumTxt(nums) {
        // console.log('nums',nums)
        if (nums) {
          var NumTxt = nums;
          var Len = NumTxt.Len;
          var arr = NumTxt.split(/\n/);
          var str = "";
          if (arr.length > 1) {
            for (var i = 0; i < arr.length; i++) {
              var NumTxt1 = arr[i].replace(/(菲尔)/, "FREY");
              //增加号码复制后对格式的处理，去掉中文和价格进行搜索
              NumTxt1 = NumTxt1.replace(/\(.*\.\d\d.*\*.*(\d+)/, "=$1");
              NumTxt1 = NumTxt1.replace(/\(.*=.+(\d+)/, "=$1");
              NumTxt1 = NumTxt1.replace(/\(.*$/, "");
              var field = arr[i].split(/\t+/);
              if (field.length == 2) {
                if (/[0-9]+/.test(field[0])) {
                  var NumTxt2 = NumTxt1.replace(/\t+(\S+)/, "=$1");
                } else {
                  var NumTxt2 = NumTxt1.replace(/\t+(\S+)/, ":$1");
                }
                str += NumTxt2 + "\n";
              } else {
                var NumTxt2 = NumTxt1.replace(/\t+(\S+)/, ":$1");
                var NumTxt3 = NumTxt2.replace(/\t+(\S+)/, "=$1");
                str += NumTxt3 + "\n";
              }
            }
          } else {
            str = arr;
          }
          // console.log('sssstr',str)
          // console.log('aaaaa',arr)
          str = str.toString();
          // 去除字符串内所有的空格
          // str = str.replace(/\s*/g,"");
          // console.log('str',str)
          this.listQuery.numberlist = str;
          // this.listQuery.numList = str;
        } else {
          str = "";
        }
        return str;
      },

      // 清空多号码
      clearNums() {
        this.listQuery.numberlist = null;
        // this.listQuery.numList = null;
      },
      // 多号码搜索
      searchNums() {
        this.listQuery.vin = null;
        this.listQuery.aikeyword = null;
        this.listQuery.page = 1;
        // this.getList();
        this.$router.push({path: '/product/productCP',query:{listQuery:JSON.stringify(this.listQuery),time:new Date().getSeconds()}});
      },
      VINSearch() {
        this.vinLoading = false;
        this.listQuery.aikeyword = null;
        if (this.listQuery.vin) {
          var str = this.listQuery.vin.toString();
          // 去除字符串内所有的空格
          str = str.replace(/\s*/g, "");
        }
        // console.log('str',str)
        if (str == null || str == "" || str.length != 17) {
          this.$refs.VINSearchIpt.$el.querySelector("input").focus();
          this.$message({
            message: "请输入正确的VIN",
            type: "warning",
            duration: 1000,
            offset: 200
          });
        } else {
          this.listQuery.numberlist = null;
          this.listQuery.page = 1;
          // this.getList();
          // this.$router.push({path: '/product/productCP',query:{listQuery:JSON.stringify(this.listQuery),time:new Date().getSeconds()}});
          this.$router.push({path: '/product/VINDetails',query:{vin:this.listQuery.vin,time:new Date().getSeconds()}});
        }
      },
      // VIN识图
      searchVINImg(e,type) {
        // console.log('666',e.target.files);
        this.vinLoading = true;
        let file = ''
        if (type) {
          file = e;
        } else{
          file = e.target.files[0];
        }
        // let file = e.target.files[0];
        let url = "";
        var reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function(ev) {
          var base64Str = ev.target.result.split(",")[1];
          // console.log('base64Str',base64Str)
          var data = {
            filebase64: base64Str
          };
          VinOcr(data).then(response => {
            // console.log('response55',response.data)
            if (response.data.status == 200) {
              that.listQuery.vin = response.data.data.vin;
              that.VINSearch();
            } else {
              that.$message({
                message: response.data.msg,
                type: "error",
                duration: 1000,
                offset: 200
              });
              this.vinLoading = false;
            }
          });
        };
      },
      // 下载模板
      downloadTemplate() {
        let url = "http://api.freyparts.cn/tpl/numtpl.xls";
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "模板.xlsx");
        document.body.appendChild(link);
        link.click();
      },
      // 表格添加成功
      upSuccess(res, file) {
        if (res.status == 200) {
          this.$message({
            message: "上传文件成功！",
            type: "success",
            duration: 1000,
            offset: 200
          });
          // this.$message.success("上传文件成功！");
          var numberlist = res.data;
          this.FormatNumTxt(numberlist);
          // this.listQuery.numberlist = this.FormatNumTxt(numberlist);
        } else {
          // this.$message.error(res.msg);
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000,
            offset: 200
          });
        }
      },
      // 粘贴图片/文字
      pasting(e){
        let that = this;
        that.vinLoading = true;
        // console.log('eeee',e)
        // console.log('eeee',e.clipboardData.items[0].kind) LBVCU5105CSE14445
        // console.log('000',e.clipboardData.files[0])
        if (!(e.clipboardData && e.clipboardData.items)) {
          return
        }
        for (var i = 0; i < e.clipboardData.items.length; i++) {
          var item = e.clipboardData.items[i];
          if (item.kind === "string") {
            item.getAsString(function(str){
              // console.log('aa',str)
              that.listQuery.vin = str;
              that.VINSearch();
            })
          } else if(item.kind === "file"){
            // console.log('55',item.getAsFile())
            let file = item.getAsFile()
            this.searchVINImg(file,'copy')
          }
        }
        // if (e.clipboardData.files[0]) {
        //   let file = e.clipboardData.files[0]
        //   this.searchVINImg(file,'copy')
        // }else{
        //   console.log(6666)
        //   // return
        // }
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .leftBar {
    // display: none;
    width: 176px;
    position: fixed;
    left: 0;
    top: 51px;
    // top: 135px;
    height: 100%;
    z-index: 999;
    padding-left: 6px;
    background-color: #ffffff;
    // border-top: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    // height: 87vh;
    .customerWrapper {
      padding: 10px 10px 10px 0;
      border-bottom: 1px solid #e4e7ed;
      .customerTitle {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        line-height: 25px;
      }
      .customerBtn {
        width: 170px;
        height: 30px;
        background: var(--mainColor);
        border-radius: 3px;
        color: white;
        text-align: center;
        cursor: pointer;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .customerName {
          width: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .el-icon-close {
          cursor: pointer;
        }
      }
    }
    .numsWrapper {
      padding-top: 18px;
      padding-bottom: 10px;
      // padding-right: 6px;
      border-bottom: 1px solid #e4e7ed;
      .textareaNum /deep/ .el-textarea__inner {
        padding: 3px;
        font-size: 12px;
      }
      .numsBtnWrapper {
        .marginT {
          margin-top: 10px;
        }
      }
      .upBtn,
      .downBtn {
        width: 170px;
        height: 30px;
        padding: 5px;
      }
      .upload-demo /deep/ .el-upload-list {
        position: absolute;
        margin-top: 25px;
        width: 100%;
      }
    }
    .VinWrapper {
      padding-top: 18px;
      padding-bottom: 10px;
      .searchIpt /deep/ .el-input__inner {
        height: 30px;
        line-height: 30px;
        padding: 0 12px 0 5px;
        font-size: 12px;
      }
      .searchIpt /deep/ .el-input__icon{
        line-height: 30px;
      }
      .VINbtnWrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        .VINiptBox {
          width: 65px !important;
          height: 34px;
          position: relative;
          cursor: pointer;
        }
        .VINbtn {
          width: 65px !important;
          height: 34px;
          background: #0046c1;
          border-radius: 4px;
          color: white;
          padding: 5px 8px;
          position: absolute;
          top: 0;
          left: 0;
          cursor: pointer;
        }
        .VINbtn img {
          vertical-align: bottom;
          cursor: pointer;
        }

        .VINipt {
          width: 65px !important;
          height: 34px;
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          z-index: 99;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/index.vue